<template>
  <section class="about-chapter-1">
    <div class="about-chapter-1-content">
      <AboutAnchorNav :section="1" />

      <v-container  class="px-sm-8 py-0 pa-md-0">
        <div class="mb-12 mb-mb-16">
          <v-row align="start" justify="space-between" no-gutters>
            <v-col cols="12" md="3">
              <p class="text-section text--fes-magenta mb-4 mb-md-0">
                The urban problems of the 21st century are starkest in Asia
              </p>
            </v-col>

            <v-col cols="12" md="8">
              <p class="text-body text--fes-blue mb-0">
                Today’s global development and climate targets call for social-ecological transformation in Asia. Why? As dense settlements of human and economic activity, Asia’s cities face unique challenges and opportunities:
              </p>                       

              <v-row align="start" justify="center" justify-md="start" class="mt-8">
                <v-col cols="12" sm="6" md="4" 
                  v-for="n in urbanproblems" 
                  :key="n.icon + '-urbanproblems'" 
                  class="about-chapter-1-urbanproblems">
                  <div 
                    :style="{ backgroundImage: 
                      'url(' + require('@/assets/about/chapter2/ch2-urbanproblems-images/about-ch2-problems-' + `${n.icon}` +'.png') + ')' 
                    }">
                    <img :src="require('@/assets/about/chapter2/about-ch2-urbanproblems-' + `${n.icon}` + '.svg')" />
                    <p class="text-card mb-0 white--text">{{ n.desc }}</p>
                  </div>
                </v-col>
              </v-row> 
            </v-col>

          </v-row>
        </div>
        
        <!-- <div class="urbanproblems-wrapper">
          <img src="@/assets/about/chapter2/about-ch2-urbanproblems-globe.svg" class="urbanproblems-globe hidden-sm-and-down" />
        </div> -->
      </v-container>       
    </div>
  </section>  
</template>

<script>
import AboutAnchorNav from '@/components/layout/AboutAnchorNav'

export default {
  name: 'AboutChapter2',
  components: {
    AboutAnchorNav
  },   
  data() {
    return {
      urbanproblems: [
        {
          "icon":"megacities",
          "desc":"More than 50 percent of the world’s megacities and urban dwellers live in Asia."
        },
        {
          "icon":"inequality",
          "desc":"High social inequality creates unsustainable growth within cities and leaves rural areas behind."
        },
        {
          "icon":"greenhousegas",
          "desc":"Asia’s greenhouse gas emissions per capita have risen  faster than any region’s over the past 20 years."
        },
        {
          "icon":"naturaldisasters",
          "desc":"Asia is among the most disaster-prone regions in the world. Its cities face drastic poverty and disease when crises hit."
        },
        {
          "icon":"climatechange",
          "desc":"Asia’s urban populations are extremely vulnerable to climate change’s impacts."
        },
        {
          "icon":"inclusivity",
          "desc":"Sustainable development approaches must address both inclusivity and accessibility."
        }
      ]
    };
  },
}
</script>

<style lang="scss" scoped>
.about-chapter-1 {
  scroll-margin-top: 70px;
}

.about-chapter-1-content {
  padding: 96px 0;
  background: linear-gradient(180deg, #E5F1F8 0%, #E8E5F1 100%);

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 48px 4px;
  }

  .about-chapter-1-urbanproblems:nth-child(-n+3) {
    margin-bottom: 8px;   
  }      

  .about-chapter-1-urbanproblems {
    div {
      min-height: 350px;
      display: flex;
      flex-direction: column;
      padding: 24px;
      background-size: cover;
      background-position: center;

      img {
        width: fit-content;
      }

      p.text-card {
        margin-top: auto;
      }      
    }
  }  
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .about-chapter-1-content {
    padding: 48px 4px;

    .about-chapter-1-urbanproblems {
      margin-bottom: 20px !important;
    }

    .about-chapter-1-urbanproblems:last-child {
      margin-bottom: unset;   
    }  
  }  
}

.urbanproblems-wrapper {
  position: relative;
  
  img.urbanproblems-globe {
    width: 95%;
    display: block;
    margin: 0 auto;
  }

  // .urbanproblems {
  //   position: absolute;
  //   top: 50%;
  //   transform: translateY(-50%);  
    
  //   @media #{map-get($display-breakpoints, 'sm-and-down')} {
  //     position: unset;
  //     top: unset;
  //     transform: unset;        
  //   }
  // }
}
</style>